import { UpdateStoreRequest } from '@fiverr-private/store_builder_types';
import pathfinder from '@fiverr-private/pathfinder';
import { type CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';

export const updateStoreData = async (storeId: string, data: UpdateStoreRequest): Promise<boolean> => {
    const url = pathfinder('ai_store_builder_api_put', {
        version: 'v1',
        store_id: storeId,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: 'update_store_data',
    };

    const response = await maxios.put(url, data, options);
    return response.status === 200;
};
